import { setGetOperatorsByIdAction } from '../action';
import { getOperatorsById } from '../api/getOperatorsById';

export const setGetOperatorsById = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getOperatorsById(params);
            dispatch(setGetOperatorsByIdAction(data.data))

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}